<div class="justify-content-center d-flex">
	<img src="assets/images/progress-transparent.gif" alt="" height="42px" class="align-self-center" />
</div>
